/**
 * NYNH Commitment Modal
 * Handles opening and closing the commitment modal with AJAX form submission
 */

class NynhCommitmentModal {
  constructor() {
    this.modal = document.getElementById('nynh-commitment-modal');
    this.form = document.getElementById('nynh-commitment-form');
    this.successMessage = document.getElementById('nynh-form-success');
    this.errorMessage = document.getElementById('nynh-form-errors');
    this.submitButton = null;
    this.init();
  }

  init() {
    if (!this.modal || !this.form) return;

    this.submitButton = this.form.querySelector('button[type="submit"]');

    // Handle form submission with AJAX
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleSubmit();
    });
  }

  async handleSubmit() {
    // Get form data
    const firstName = document.getElementById('nynh-first-name').value.trim();
    const lastName = document.getElementById('nynh-last-name').value.trim();
    const email = document.getElementById('nynh-email').value.trim();

    // Validate
    if (!firstName || !lastName || !email) {
      this.showError('Please fill in all required fields.');
      return;
    }

    // Show loading state
    this.setLoading(true);
    this.hideError();

    try {
      if (window._learnq) {
        // Subscribe to list
        window._learnq.push(['identify', {
          '$email': email,
          '$first_name': firstName,
          '$last_name': lastName,
          'commitment_date': new Date().toISOString(),
          'commitment_source': 'NYNH Website'
        }]);

        // Track commitment event
        window._learnq.push(['track', 'NYNH Commitment', {
          '$email': email,
          '$first_name': firstName,
          '$last_name': lastName
        }]);

        this.showSuccess();
      } else {
        this.showError('Unable to process your commitment. Please try again.');
        this.setLoading(false);
      }
    } catch (error) {
      console.error('Klaviyo error:', error);
      this.showError('An error occurred. Please try again.');
      this.setLoading(false);
    }
  }

  showSuccess() {
    // Hide form
    this.form.style.display = 'none';

    // Show success message
    if (this.successMessage) {
      this.successMessage.style.display = 'block';
    }

    // Auto-close after 3 seconds
    setTimeout(() => {
      this.close();
      this.resetForm();
    }, 3000);
  }

  showError(message) {
    if (this.errorMessage) {
      this.errorMessage.textContent = message;
      this.errorMessage.style.display = 'block';
    }
  }

  hideError() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }

  setLoading(isLoading) {
    if (!this.submitButton) return;

    const buttonText = this.submitButton.querySelector('.button-text');
    const buttonLoader = this.submitButton.querySelector('.button-loader');

    if (isLoading) {
      this.submitButton.disabled = true;
      if (buttonText) buttonText.style.display = 'none';
      if (buttonLoader) buttonLoader.style.display = 'inline-block';
    } else {
      this.submitButton.disabled = false;
      if (buttonText) buttonText.style.display = 'inline';
      if (buttonLoader) buttonLoader.style.display = 'none';
    }
  }

  resetForm() {
    this.form.reset();
    this.form.style.display = 'block';
    if (this.successMessage) {
      this.successMessage.style.display = 'none';
    }
    this.hideError();
    this.setLoading(false);
  }

  open() {
    if (this.modal) {
      this.resetForm();
      this.modal.show();
    }
  }

  close() {
    if (this.modal) {
      this.modal.hide();
    }
  }
}

// Global function to open the modal (can be called from anywhere)
window.openNynhCommitmentModal = function() {
  const modal = document.getElementById('nynh-commitment-modal');
  if (modal && modal.show) {
    modal.show();
  }
};

// Global function to close the modal
window.closeNynhCommitmentModal = function() {
  const modal = document.getElementById('nynh-commitment-modal');
  if (modal && modal.hide) {
    modal.hide();
  }
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new NynhCommitmentModal();
  });
} else {
  new NynhCommitmentModal();
}
